var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "col content-spacing",
      staticStyle: { "max-width": "88% !important" },
      attrs: { role: "main" }
    },
    [
      _c(
        "section",
        [
          _c(
            "PageHeader",
            {
              staticStyle: { "padding-top": "1rem" },
              attrs: { pageTitle: "Usuários" }
            },
            [
              _c(
                "div",
                { staticStyle: { display: "flex", gap: "0.5rem" } },
                [
                  _c("GenericSearchInput", {
                    model: {
                      value: _vm.search.textSearch,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "textSearch", $$v)
                      },
                      expression: "search.textSearch"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectProfile", {
                    model: {
                      value: _vm.search.profile,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "profile", $$v)
                      },
                      expression: "search.profile"
                    }
                  }),
                  _vm._v(" "),
                  _c("SelectAccountManager", {
                    model: {
                      value: _vm.search.accountManagerId,
                      callback: function($$v) {
                        _vm.$set(_vm.search, "accountManagerId", $$v)
                      },
                      expression: "search.accountManagerId"
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "BaseButtonComponent",
                    {
                      attrs: {
                        variant: "primary-action",
                        disabled: !_vm.userList.length
                      },
                      on: {
                        click: function($event) {
                          return _vm.getAll()
                        }
                      }
                    },
                    [_vm._v("\n          Buscar\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "VueJsonToCsv",
                    {
                      attrs: {
                        block: "",
                        "json-data": _vm.CSVUserList,
                        separator: ";"
                      }
                    },
                    [
                      _c(
                        "BaseButtonComponent",
                        {
                          attrs: {
                            block: "",
                            variant: "primary-action",
                            disabled: !_vm.CSVUserList.length
                          }
                        },
                        [_vm._v("\n            CSV\n          ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isLoading
        ? _c("b-skeleton-table", {
            staticStyle: { "margin-top": "2rem" },
            attrs: {
              animation: "wave",
              rows: 5,
              columns: 15,
              "table-props": { bordered: true, striped: true }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "d-flex justify-content-between flex-column" },
        [
          !_vm.isLoading && _vm.userList.length !== 0
            ? _c(
                "Table",
                {
                  staticClass: "user-table",
                  staticStyle: { "margin-top": "1rem" }
                },
                [
                  _c(
                    "TableHeader",
                    [
                      _c(
                        "TableRow",
                        _vm._l(_vm.userColumns, function(userCol, index) {
                          return _c(
                            "TableHead",
                            { key: `${userCol}_${index}` },
                            [
                              _c("ColumnHeader", {
                                attrs: {
                                  sort: userCol.sort,
                                  somatory: userCol.somatory,
                                  columnName: userCol.name,
                                  columnKey: userCol.key,
                                  columnType: userCol.columnType,
                                  currentColumnFiltered:
                                    _vm.currentColumnFiltered,
                                  sortDirection: _vm.sortDirection,
                                  dataList: _vm.userList
                                },
                                on: {
                                  sortListByKey: function($event) {
                                    return _vm.sortListByKey(userCol.key)
                                  }
                                }
                              })
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "TableBody",
                    _vm._l(_vm.userList, function(user, index) {
                      return _c(
                        "TableRow",
                        { key: `${user}_${index}` },
                        [
                          _c(
                            "TableCell",
                            [
                              _c("RenderSocialNumberColumnValue", {
                                attrs: { socialNumber: user.socialNumber }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.name) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("RenderPhoneColumnValue", {
                                attrs: { phoneNumber: user.phone }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.email) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c(
                                "b-form-input",
                                _vm._b(
                                  {
                                    staticStyle: { width: "9rem" },
                                    model: {
                                      value: user.nameCoupon,
                                      callback: function($$v) {
                                        _vm.$set(user, "nameCoupon", $$v)
                                      },
                                      expression: "user.nameCoupon"
                                    }
                                  },
                                  "b-form-input",
                                  false,
                                  false
                                )
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.state) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.zipCode) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.city) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.district) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.address) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _vm.accountManagerOptions.length
                            ? _c(
                                "TableCell",
                                { staticStyle: { "min-width": "200px" } },
                                [
                                  _c("SelectAccountManager", {
                                    attrs: {
                                      "options-data": _vm.accountManagerOptions
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.setAccountManager(user)
                                      }
                                    },
                                    model: {
                                      value: user.accountManagerId,
                                      callback: function($$v) {
                                        _vm.$set(user, "accountManagerId", $$v)
                                      },
                                      expression: "user.accountManagerId"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.dateWithHourFormat(user.createdAt)) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c("TableCell", [
                            _vm._v(
                              "\n            " +
                                _vm._s(user.lastApiAccess) +
                                "\n          "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("b-form-checkbox", {
                                attrs: {
                                  checked: Boolean(user.hasUcAvailable)
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.updateHasUcAvailable(user)
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("b-form-checkbox", {
                                attrs: {
                                  checked: Boolean(user.consumer),
                                  disabled: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("b-form-checkbox", {
                                attrs: {
                                  checked: Boolean(user.investor),
                                  disabled: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c("b-form-checkbox", {
                                attrs: {
                                  checked: Boolean(user.trader),
                                  disabled: true
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "TableCell",
                            [
                              _c(
                                "BaseButtonComponent",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "primary-action",
                                    disabled: !user.nameCoupon
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.changeCouponName(
                                        user.id,
                                        user.nameCoupon
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        user.nameCoupon
                                          ? "Alterar Cupom"
                                          : "Adicionar Cupom"
                                      ) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "BaseButtonComponent",
                                {
                                  attrs: {
                                    size: "sm",
                                    variant: "primary-action"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.openUserDetailsDialog(user)
                                    }
                                  }
                                },
                                [_vm._v("\n              Editar\n            ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            : !_vm.isLoading
            ? _c("empty-list")
            : _vm._e(),
          _vm._v(" "),
          _c("AlphabetPagination", {
            on: { "letter-selected": _vm.fetchDataForLetter }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("EditUserDetailsDialog", {
        ref: "editUserDetailsModalRef",
        on: { getAll: _vm.getAll }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }